import { useContext, useEffect, useRef } from "react";
import MembersContext from "../../context/MembersContext";
import CustomButton from "../CustomButton";
import CustomTextField from "../CustomTextField";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import MenuItem from "@mui/material/MenuItem";
import ClearIcon from "@mui/icons-material/Clear";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import DashboardContext from "../../context/DashboardContext";

export default function MembersFilter() {
  const {
    filterTypeInput,
    setFilterTypeInput,
    cpfInput,
    nameInput,
    addressInput,
    addressNumInput,
    handleFilterInputChange,
    submitFilter,
    handleResetFilterButton,
    cpfError,
    productType,
    setProductType,
    initialDate,     // Data inicial
    finalDate,       // Data final
  } = useContext(MembersContext);

  const { products, clientId } = useContext(DashboardContext);

  const textInputRef = useRef(null);

  useEffect(() => {
    if (textInputRef.current) {
      textInputRef.current.focus();
    }
  }, [filterTypeInput]);

  return (
    <form
      onSubmit={submitFilter}
      style={{
        alignItems: "center",
        display: "flex",
      }}
    >
      <Stack mr={1} spacing={1} sx={{ width: "100%" }}>
        <CustomTextField
          color="primary"
          label="Filtrar por"
          name="filterTypeInput"
          onChange={({ target: { value } }) => setFilterTypeInput(value)}
          select
          size="small"
          value={filterTypeInput}
          variant="outlined"
        >
          <MenuItem value="cpf">CPF do associado</MenuItem>
          <MenuItem value="name">Nome do associado</MenuItem>
          {clientId == "2546" && <MenuItem value="address">Condomínio</MenuItem>}
          {clientId == "2546" && <MenuItem value="addressNum">Apartamento</MenuItem>}
          <MenuItem value="product">Produto</MenuItem>
          <MenuItem value="registrationDate">Data de Cadastro</MenuItem>
        </CustomTextField>

        {filterTypeInput === "cpf" && (
          <CustomTextField
            inputRef={textInputRef}
            autoComplete="off"
            color="primary"
            error={cpfError}
            helperText={cpfError && "O CPF precisa ter 11 números"}
            label="Digite aqui"
            name="cpfInput"
            onChange={handleFilterInputChange}
            size="small"
            type="text"
            value={cpfInput}
            variant="outlined"
          />
        )}
        {filterTypeInput === "name" && (
          <CustomTextField
            inputRef={textInputRef}
            autoComplete="off"
            color="primary"
            label="Digite aqui"
            name="nameInput"
            onChange={handleFilterInputChange}
            size="small"
            type="text"
            value={nameInput}
            variant="outlined"
          />
        )}
        {filterTypeInput === "address" && (
          <CustomTextField
            inputRef={textInputRef}
            autoComplete="off"
            color="primary"
            label="Digite aqui"
            name="addressInput"
            onChange={handleFilterInputChange}
            size="small"
            type="text"
            value={addressInput}
            variant="outlined"
          />
        )}
        {filterTypeInput === "addressNum" && (
          <CustomTextField
            inputRef={textInputRef}
            autoComplete="off"
            color="primary"
            label="Digite aqui"
            name="addressNumInput"
            onChange={handleFilterInputChange}
            size="small"
            type="text"
            value={addressNumInput}
            variant="outlined"
          />
        )}
        {filterTypeInput === "product" && (
          <CustomTextField
            color="primary"
            label="Filtrar por"
            name="filterTypeInput"
            onChange={({ target: { value } }) => setProductType(value)}
            select
            size="small"
            value={productType}
            variant="outlined"
          >
            {products?.map((el) => (
              <MenuItem key={`prodkey-${el.id}`} value={el.id}>{el.name.toLowerCase()}</MenuItem>
            ))}
          </CustomTextField>
        )}

        {filterTypeInput === "registrationDate" && (
          <>
            <CustomTextField
              color="primary"
              label="Data Inicial"
              type="date"
              name="initialDate"
              value={initialDate}
              onChange={handleFilterInputChange}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              variant="outlined"
            />
            <CustomTextField
              color="primary"
              label="Data Final"
              type="date"
              name="finalDate"
              value={finalDate}
              onChange={handleFilterInputChange}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              variant="outlined"
            />
          </>
        )}
      </Stack>

      <Stack spacing={1}>
        <Tooltip title="Descartar filtro">
          <CustomButton
            color="error"
            size="small"
            sx={{ maxWidth: "40px", minWidth: "40px" }}
            onClick={handleResetFilterButton}
            type="button"
            variant="contained"
          >
            <ClearIcon />
          </CustomButton>
        </Tooltip>

        <Tooltip title="Filtrar">
          <CustomButton
            color="primary"
            size="small"
            sx={{ maxWidth: "40px", minWidth: "40px" }}
            type="submit"
            variant="contained"
          >
            <FilterAltIcon />
          </CustomButton>
        </Tooltip>
      </Stack>
    </form>
  );
}
